import React from "react";
import banner_image from "../../assets/images/banner_image.png";
import "./Main.scss";

const Main = () => {
  return (
    <section className="as_banner_wrapper" id="home">
      <div className="container">
        <div className="row as_verticle_center">
          <div className="col-lg-6 order-lg-1 col-md-6 order-md-1 col-sm-12 order-sm-1 col-12 order-2">
            <div className="as_banner_slider">
              <div className="as_banner_detail">
                <h1 data-aos="fade-right" data-aos-delay="200">
                  Never Wrong Astrology,
                  <br /> May Be Astrologer.
                </h1>
                <div className="appointmentbutton">
                  <a
                    href="#appointment"
                    data-aos="fade-up"
                    data-aos-delay="200"
                    className="as_btn book_btn"
                  >
                    Book an appoinment
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 order-lg-2 col-md-6 order-md-2 col-sm-12 order-sm-2 col-12 order-1"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <div className="as_banner_img text-center">
              <img src={banner_image} alt="" className="image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Main;
